import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

import { AuthService } from '../auth.service';
import { User } from '../../shared/models/user';
import { Router } from '@angular/router';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {
    this.authService.navigateToWelcome();
  }

  ngOnInit() {
  }

  onSend(form: NgForm) {
    const router = this.router;
    this.authService.forgotUser(form.value.email)
      .subscribe(
        (res) => {

          if( !res['success'] ){
            alert("failed")
            return
          }

          swal({
            title: 'Check your inbox',
            text: 'We have sent you an email. Please check your inbox and click on the link within the email to reset your password.',
            timer: 20000,
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: 'custom-swal2-hook'
          }).then(
            function () {
              router.navigate(['/signin']);
            },
          )
        },
      );

    return false;
  }

  onKeyDownFunction(event, f) {
    if (event.keyCode == 13) {
      return this.onSend(f);
    }
  }
}
